module.exports = __webpack_public_path__ + "media/images/flags/cc-753c86c411ca6a387efb6d434ae9d3aa.svg";